import { FC, useState } from 'react'
import {
  Control,
  FieldErrors,
  UseFormClearErrors,
  UseFormSetValue,
  UseFormGetValues,
  UseFormSetError,
  UseFormHandleSubmit,
} from 'react-hook-form'

import Button from 'components/parts/button/button'
import ControllerBaseInput from 'components/form-parts/controller-hook-forms/controller-base-input/controller-base-input'

import { FieldId, FormValues } from '../../data'
import { FieldsNameVoc, emailValidation } from 'constants/auth/profile-data'
import { nestApiPath } from 'constants/url'
import { getAxiosSingle } from 'pages/api/axios'
import { RegStep } from '../../data'

import common from '../../registration-code.module.scss'

interface IEmaiWidget {
  control: Control<FormValues>
  errors: FieldErrors
  clearErrors: UseFormClearErrors<FormValues>
  getValues: UseFormGetValues<FormValues>
  setValue: UseFormSetValue<FormValues>
  setStep: React.Dispatch<React.SetStateAction<RegStep>>
  handleSubmit: UseFormHandleSubmit<FormValues>
}

const EmaiWidget: FC<IEmaiWidget> = ({
  control,
  errors,
  setStep,
  setValue,
  getValues,
  clearErrors,
  handleSubmit,
}) => {
  const [isSending, setSending] = useState(false)
  const isButtonDisabled = isSending || Boolean(errors[FieldsNameVoc.email])
  const enterHandler = async () => {
    const currValues = getValues()
    const email = currValues[FieldsNameVoc.email]

    if (email && !errors[FieldsNameVoc.email]) {
      setSending(true)

      const userData = await getAxiosSingle(`${nestApiPath}/user/checkemail?email=${email}`)
      if (userData?.isExists === true) {
        setStep(RegStep.EMAIL_FLOW_OK)
        setValue(FieldId, userData.id)
        return
      }
      if (userData?.isExists === false) {
        setStep(RegStep.NEW_REG_FLOW)
        return
      }
      if (userData?.response?.status === 409) {
        setStep(RegStep.ERROR)
      }

      setStep(RegStep.ERROR)
      setSending(false)
    }
  }
  return (
    <div className={common.wrapperCommon}>
      <div className={common.title}>Введите почту</div>
      <div className={common.inputWrap}>
        <ControllerBaseInput
          control={control}
          name={FieldsNameVoc.email}
          errors={errors}
          noName
          noErrorOnTouch={clearErrors}
          rules={emailValidation}
        />
      </div>
      <Button disabled={isButtonDisabled} onClick={handleSubmit(enterHandler)}>
        {isSending ? 'Отправка...' : 'Войти в аккаунт'}
      </Button>
    </div>
  )
}

export default EmaiWidget
